export default "__VITE_ASSET__9T8mZ7Yb__"